import React, { useState, useEffect } from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import PageTransition from "./motion/PageTransition";

const Layout = ({ children }) => {
  const [darkMode, setDarkMode] = useState(() => {
    const storedDarkMode = localStorage.getItem("darkMode");
    return storedDarkMode === "true" || false;
  });

  useEffect(() => {
    document.documentElement.classList.toggle("dark", darkMode);
    localStorage.setItem("darkMode", darkMode);
  }, [darkMode]);

  return (
    <div className={`min-h-screen h-full flex flex-col ${darkMode ? "dark" : ""}`}>
      <Navbar darkMode={darkMode} toggleDarkMode={() => setDarkMode((v) => !v)} />
      {/* Keep main neutral; pages decide their own backgrounds */}
      <main className="relative flex-grow pt-16">
        <PageTransition>{children}</PageTransition>
      </main>

      <Footer />
    </div>
  );
};

export default Layout;
